import { render, staticRenderFns } from "./announcementModal.vue?vue&type=template&id=45b61abc&scoped=true&lang=pug&"
import script from "./announcementModal.vue?vue&type=script&lang=js&"
export * from "./announcementModal.vue?vue&type=script&lang=js&"
import style0 from "./announcementModal.vue?vue&type=style&index=0&id=45b61abc&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b61abc",
  null
  
)

export default component.exports